<template>
  <div class="teacher_scheduling">

    <!-- 头部筛选 -->
    <div class="header_select">
      <el-icon class="header_icon" color="#4484f3" :size="20"><Avatar /></el-icon>选择值班老师：
      <el-select v-model="teacherChangeKey" class="m-2" placeholder="请选择值班老师" size="large">
        <el-option
          v-for="item in teacherList"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-icon class="header_icon" color="#4484f3" :size="20"><Avatar /></el-icon>排班类型：
      <el-select v-model="data.Category" class="m-2" @change="selectChange" placeholder="请选择排班类型" size="large">
        <el-option
          v-for="item in categoryList"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-icon class="header_icon" color="#4484f3" :size="20"><Avatar /></el-icon>日期选择：
      <el-select v-model="year" class="m-2" placeholder="请选择日期" size="large">
        <el-option
          v-for="item in yearList"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-select v-model="month"  class="m-2" placeholder="Select" size="large">
        <el-option
          v-for="item in monthList"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <div class="question">
        <el-popover
          placement="bottom-start"
          title="班次时间说明:"
          :width="200"
          trigger="click"
          
        >
          <div>
            <p>早班时间：08:30-12:30</p>
            <p>中班时间：12:30-18:00</p>
            <p>晚班时间：18:00-22:00</p>
          </div>
          <template #reference>
            <el-button type="danger"><el-icon><QuestionFilled /></el-icon>班次时间说明
            </el-button>
            
          </template>
        </el-popover>
      </div>
    </div>
   
    
    <!-- 表格 -->
    <div class="scroll_table" v-loading="loading">
      <div class="row_table">
      <div v-for="item2 in rowData" :key="item2.id" class="table_flex">
        <div class="table_flex_item">
          <div class="table_title" :class="index==0?'bg_blue':''" v-for="item,index in headerData" :key="index">{{ item.key }}</div>
        </div>
        <div class="table_flex_item2" v-for="item,index in item2.data" :key="index">
          <div class="bg_blue">{{ item.scheduleTime }}</div>
          <div class="table_info" @click="addName(1,item.morningName,item.scheduleTime)">
            <div v-if="item.morningName"><el-icon class="Select_name" color="#4484f3" :size="25"><Select /></el-icon>{{ item.morningName }}</div>
            <el-icon v-else :size="20" color="#ccc"><CircleCloseFilled /></el-icon>
          </div>
          <div class="table_info" @click="addName(2,item.noonName,item.scheduleTime)">
            <div v-if="item.noonName"><el-icon class="Select_name" color="#4484f3" :size="25"><Select /></el-icon>{{ item.noonName }}</div>
            <el-icon v-else :size="20" color="#ccc"><CircleCloseFilled /></el-icon>
          </div>
          <div class="table_info" @click="addName(3,item.nightName,item.scheduleTime)">
            <div v-if="item.nightName"><el-icon class="Select_name" color="#4484f3" :size="25"><Select /></el-icon>{{ item.nightName }}</div>
            <el-icon v-else :size="20" color="#ccc"><CircleCloseFilled /></el-icon>
          </div>
        </div>
      </div>
    </div>
    </div>

    <!-- 提交 -->
    <div class="from_btn">
        <el-button @click="getData" size="large">取消</el-button>
        <el-button type="primary" v-if="!submitDisabled" size="large" @click="submitForm" :disabled = "submitDisabled">提交</el-button>
        <el-button type="primary" size="large" loading v-else>提交中</el-button>
    </div>

     <!-- 批量操作结果响应 -->
      <el-dialog
        :close-on-click-modal="false"
        v-model="resultVisible"
        :title="resultTitle"
        width="900px"
        append-to-body="false"
        draggable
        destroy-on-close
      >
        <ResultList :resultList="resultList"></ResultList>
      </el-dialog>
   
  </div>
</template>

<script>
import ResultList from "@/components/ResultList.vue"
import { GetSchedule,SetSchedule} from "@/network/teacherScheduling.js";
import { ElMessage, ElMessageBox } from "element-plus";
export default {
  name:'TeacherScheduling',
  components:{
    ResultList
  },
  data(){
    return {
      resultVisible:false,
      resultList:[],
      resultTitle:'排班详情',
      loading:false,
      data:{
        ScheduleTime: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-1',
        Category: 1
      },
      // 选中的老师
      teacherChangeKey: null,
      teacherChangeName:'',
      //表格数据
      tableData: [],
      // 老师列表
      teacherList:[],
      // 年
      yearList:[],
      year: new Date().getFullYear(),
      // 月
      monthList:[
        {key:1,value:1},
        {key:2,value:2},
        {key:3,value:3},
        {key:4,value:4},
        {key:5,value:5},
        {key:6,value:6},
        {key:7,value:7},
        {key:8,value:8},
        {key:9,value:9},
        {key:10,value:10},
        {key:11,value:11},
        {key:12,value:12},
      ],
      month: new Date().getMonth() + 1,
      // 排班类型
      categoryList:[],
      //表头数据
      headerData: [
        {
          key: "时间",
        },
        {
          key: "早班",
        },
        {
          key: "中班",
        },
        {
          key: "晚班",
        },
      ],
      howWidth: 8,
      rowData:[],
      // 提交按钮
      submitDisabled: false,

    }
  },
  created(){
    this.getData()
    this.getYear()
  },
  watch: {
    "year": {
      handler(newVal, oldVal) {
          this.data.ScheduleTime = newVal + '-' + this.month + '-1'
          this.getData()
      }
    },
    "month": {
      handler(newVal, oldVal) {
          this.data.ScheduleTime = this.year + '-' + newVal + '-1'
          this.getData()
      }
    },
    "teacherChangeKey": {
      handler(newVal, oldVal) {
          this.teacherList.map((item)=>{
            if(item.key == this.teacherChangeKey){
              this.teacherChangeName = item.value
            }
          })
      },
      deep:true,
    },
    "tableData": {
      handler(newVal, oldVal) {
        this.rowData = [
          {id:1,data:newVal.slice(0,7)},
          {id:2,data:newVal.slice(7,14)},
          {id:3,data:newVal.slice(14,21)},
          {id:4,data:newVal.slice(21,28)},
        ]
        if(this.tableData.length > 28){
          this.rowData.push({id:5,data:newVal.slice(28,35)},)
        }
      },
      deep:true,
    },
  },
  methods:{
   resultHandle(result){
           
    if(result?.result.length){
      let arr = []
      arr = result.result.filter(item=>item.code !== 1)
      if(arr.length){
        data.resultVisible = true
        data.resultList = arr
      }else{
        ElMessageBox.alert(result.message, "提示", {
          confirmButtonText: "确认",
        });
      }
     
    }else{
      ElMessageBox.alert(result.message, "提示", {
        confirmButtonText: "确认",
      });
    }
  },
    async getData(){
      this.loading = true
      let res = await GetSchedule(this.data)
      if(res.code == 1){
        this.loading = false
        this.tableData = res.result.scheduleList
        this.teacherList = res.result.teacherList
        this.categoryList = res.result.categoryList
        this.teacherChangeKey = this.teacherList[0].key
      }else{
        this.loading = false
        ElMessage.error(res.message);
      }
    },
    selectChange(){
     this.getData()
    },
    // 获取年份列表
    getYear(){
      let year = new Date().getFullYear()
      for(let i=-1;i<2;i++){
        this.yearList.push({
          key:year + i,
          value:year + i + '年'
        })
      }
    },
    async submitForm(){
      let scheduleList = []
      this.tableData.forEach(item => {
        if(item.morningId != 0){
          scheduleList.push({
            scheduleTime: item.scheduleTime.slice(0,5),
            teacherId: item.morningId,
            shift: 1,
            category: this.data.Category 
          }) 
        }
        if(item.noonId != 0){
          scheduleList.push({
            scheduleTime: item.scheduleTime.slice(0,5),
            teacherId: item.noonId,
            shift: 2,
            category: this.data.Category 
          }) 
        }
        if(item.nightId != 0){
          scheduleList.push({
            scheduleTime: item.scheduleTime.slice(0,5),
            teacherId: item.nightId,
            shift: 3,
            category: this.data.Category 
          }) 
        }
      })
      if(scheduleList.length < 1){
        return
      }
      let data = {
        date: this.data.ScheduleTime,
        category: this.data.Category,
        scheduleList:scheduleList
      }
      this.loading = true
      this.submitDisabled = true
      let res = await SetSchedule(data)
      if(res.code == 1){
        this.loading = false
        this.submitDisabled = false
        // ElMessageBox.alert(res.message, "提示", {
        //   confirmButtonText: "确认",
        // });
        this.getData()
        this.resultHandle(res)
      }else{
        this.loading = false
        this.submitDisabled = false
        this.resultHandle(res)
      }
    },
    // type 1 早班 2中班 3晚班
    addName(type,name,time){
      if(name){
        this.delName(type,time)
        
      }else{
        
        if(type == 1){
          this.tableData.map((item)=>{
            if(item.scheduleTime == time){
              item.morningId = this.teacherChangeKey
              item.morningName = this.teacherChangeName
            }
          })
        }else if(type == 2){
          this.tableData.map((item)=>{
            if(item.scheduleTime == time){
              item.noonId = this.teacherChangeKey
              item.noonName = this.teacherChangeName
            }
          })
        }else if(type == 3){
          this.tableData.map((item)=>{
            if(item.scheduleTime == time){
              item.nightId = this.teacherChangeKey
              item.nightName = this.teacherChangeName
            }
          })
        }
      }
      
    },
    delName(type,time){
      if(type == 1){
        this.tableData.map((item)=>{
          if(item.scheduleTime == time){
            item.morningId = 0
            item.morningName = null
          }
        })
      }else if(type == 2){
          this.tableData.map((item)=>{
            if(item.scheduleTime == time){
              item.noonId = 0
              item.noonName = null
            }
          })
        }else if(type == 3){
          this.tableData.map((item)=>{
            if(item.scheduleTime == time){
              item.nightId = 0
              item.nightName = null
            }
          })
        }
    },
    
  }
}
</script>

<style scoped>
.header_select{
  width: 1600px;
  margin-bottom: 10px;
}
.question{
  display: inline-block;
  margin-left: 20px;
}
.header_icon{
  vertical-align: text-bottom;
}
.table_flex{
  display: flex;
}
.table_flex_item{
  width: 80px;
}
.table_flex_item2{
  width: 200px;
}
.teacher_scheduling {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.scroll_table{
  width: 100%;
  height: 660px;
  overflow-y: scroll;
}
.row_table{
  width: 1480px;
  border: 1px solid #ddd;
}
.bg_blue{
  color: #fff;
  background-color: #4484f3;
  text-align: center;
  width: 200px;
  height: 40px !important;
  line-height: 40px !important;
  border-bottom: 1px solid #ddd;
  border-right: 1px solid #ddd;
}
.table_title{
  width: 80px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border-bottom: 1px solid #ddd;
  border-right: 1px solid #ddd;
}
.table_info{
  width: 200px;
  height: 50px;
  line-height: 50px;
  text-align: left;
  padding-left: 20px;
  border-bottom: 1px solid #ddd;
  border-right: 1px solid #ddd;
}
.Select_name{
  vertical-align: middle;
}
.from_btn{
  width:300px;
  margin-left: 0;
  border: none;
}
/deep/.el-button--large{
  padding: 12px 45px;
}
</style>